// Cleans HTML pasted into Trix editors so that empty "spacer" paragraphs from
// Word/Outlook/Gmail/Google Docs don't get turned into blank Trix blocks. Those
// empty blocks render as extra vertical gaps between paragraphs in the emails we
// send (e.g. the paid session welcome email). See WRE-655.

export function cleanPastedHtml(html) {
  if (!html) return html;
  return html
    // Office conditional comments and namespaced tags
    .replace(/<!--[\s\S]*?-->/g, '')
    .replace(/<\/?o:p[^>]*>/gi, '')
    // Empty paragraphs/divs used purely as inter-paragraph spacers
    .replace(/<p\b[^>]*>(?:\s|&nbsp;|<br\s*\/?>)*<\/p>/gi, '')
    .replace(/<div\b[^>]*>(?:\s|&nbsp;|<br\s*\/?>)*<\/div>/gi, '')
    // Runs of <br> collapsed to a single break
    .replace(/(?:<br\s*\/?>\s*){2,}/gi, '<br>')
    // Trailing whitespace text nodes between blocks
    .replace(/>\s+</g, '><');
}

export function interceptTrixPaste(event) {
  const trixEditor = event.target.closest && event.target.closest('trix-editor');
  if (!trixEditor || !trixEditor.editor) return;

  const dt = event.clipboardData || window.clipboardData;
  if (!dt) return;

  const html = dt.getData('text/html');
  if (!html) return; // plain-text paste — let Trix handle it natively

  const cleaned = cleanPastedHtml(html);
  if (cleaned === html) return; // nothing to do

  event.preventDefault();
  event.stopPropagation();
  trixEditor.editor.insertHTML(cleaned);
}
